import React, { useState } from "react";

function Alert({ message, closable = false }) {
  const [visible, setVisible] = useState(true);

  const handleClose = () => {
    setVisible(false);
  };

  return visible ? (
    <div className="warning-card">
      <p className="paragraph-md text-warning-900">
        Complete your application by entering the recommended details to
        continue.
      </p>
      {closable && <i className="fa fa-times x-icon" onClick={handleClose}></i>}
    </div>
  ) : null;
}

export default Alert;
